export interface FieldRequirement {
  product: string
  feature: string
  field: string
  status: string
  section: string
}

export interface FieldWithSources extends FieldRequirement {
  sources: string[] // Array of "Product - Feature" strings
}

export const fieldRequirementsData: FieldRequirement[] = [
  // Constituent ID
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Constituent ID Matching',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Events',
    feature: 'Constituent ID Matching',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // First Name
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Constituent ID Matching',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Events',
    feature: 'Constituent ID Matching',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // Last Name
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Constituent ID Matching',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Events',
    feature: 'Constituent ID Matching',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // Preferred First Name
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Preferred First Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Preferred First Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Preferred First Name',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Preferred First Name',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Preferred First Name',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Preferred First Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Preferred First Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Preferred First Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Preferred First Name',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Prefix
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Prefix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Prefix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Prefix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Prefix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Prefix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Prefix',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Middle Name
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Middle Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Middle Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Middle Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Middle Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Middle Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Middle Name',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Nickname
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Nickname',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Nickname',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Nickname',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Nickname',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Nickname',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Suffix
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Suffix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Suffix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Suffix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Suffix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Suffix',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Former Last Name
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Former Last Name',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Preferred Email
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Constituent ID Matching',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Events',
    feature: 'Constituent ID Matching',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // Business Email
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Constituent ID Matching',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Events',
    feature: 'Constituent ID Matching',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Other Email
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Constituent ID Matching',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Events',
    feature: 'Constituent ID Matching',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Birth Date
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Birth Date',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Birth Date',
    status: 'Optional (filters)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Birth Date',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Birth Date',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Birth Date',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Birth Date',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Birth Date',
    status: 'Optional (filters)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Birth Date',
    status: 'Optional (filters)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Birth Date',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Birth Date',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Birth Date',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Cell Phone
  {
    product: 'Events',
    feature: 'Constituent ID Matching',
    field: 'Cell Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Cell Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Cell Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Cell Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Cell Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Cell Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Cell Phone',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Cell Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Cell Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Cell Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Cell Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Cell Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Home Phone
  {
    product: 'Events',
    feature: 'Constituent ID Matching',
    field: 'Home Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Home Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Home Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Home Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Home Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Home Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Home Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Home Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Home Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Home Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Preferred Phone
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Preferred Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Work Phone
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Work Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Work Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Work Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Work Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Work Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Work Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Work Phone',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Work Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Class Year
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Class Year',
    status: 'Optional (filters)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Class Year',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Class Year',
    status: 'Optional (filters)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Class Year',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Class Year',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Class Year',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Class Year',
    status: 'Optional (filters, merge tokens)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Class Year',
    status: 'Optional (filters, merge tokens)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Class Year',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Class Year',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Class Year',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Class Year',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Class Year',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Class Year',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Ask Amount
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Ask Amount',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Ask Amount',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Ask Amount',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Ask Amount',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Ask Amount',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Ask Amount',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Ask Amount',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Ask Amount',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Ask Amount',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Ask Amount',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Lifetime Giving
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Lifetime Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Lifetime Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Lifetime Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Lifetime Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Lifetime Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Lifetime Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Lifetime Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Lifetime Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Prospect Manager
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Prospect Manager',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Prospect Manager',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Prospect Manager',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Prospect Manager',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Prospect Manager Email
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Prospect Manager Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Prospect Manager Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Prospect Manager Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Prospect Manager Email',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Employer
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Employer',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Employer',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Employer',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Employer',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Employer',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Job Title
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Job Title',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Job Title',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Job Title',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Job Title',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Job Title',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Deceased
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Deceased',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Deceased',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Deceased',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Total Years Giving
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Total Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Total Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Total Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Total Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Total Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Total Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Total Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Total Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Total Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Total Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Consecutive Years Giving
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Consecutive Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Consecutive Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Consecutive Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Consecutive Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Consecutive Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Consecutive Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Consecutive Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Consecutive Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Consecutive Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Consecutive Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Fiscal Year Giving
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Fiscal Year Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Fiscal Year Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Fiscal Year Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Fiscal Year Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Fiscal Year Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Fiscal Year Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Fiscal Year Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Fiscal Year Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Fiscal Year Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Fiscal Year Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Prospect Status
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Prospect Status',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Prospect Classification
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Prospect Classification',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // SECTION: Constituent - Address

  // Constituent - Address Label
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Constituent - Address Label',
    status: 'Optional',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Constituent - Address Label',
    status: 'Optional',
    section: 'Constituent - Address',
  },

  // Constituent - Address Country
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Constituent - Address Country',
    status: 'Optional',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Constituent - Address Country',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Constituent - Address Country',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Constituent - Address Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Constituent - Address Country',
    status: 'Required',
    section: 'Constituent - Address',
  },

  // Constituent - AddressCity
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Constituent - AddressCity',
    status: 'Optional',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Constituent - AddressCity',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Constituent - AddressCity',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Constituent - AddressCity',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Constituent - AddressCity',
    status: 'Required',
    section: 'Constituent - Address',
  },

  // Zipcode
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Zipcode',
    status: 'Optional',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Zipcode',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Zipcode',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Zipcode',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Zipcode',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Zipcode',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Zipcode',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Zipcode',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Zipcode',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Zipcode',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Zipcode',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Zipcode',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Zipcode',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Zipcode',
    status: 'Required',
    section: 'Constituent - Address',
  },

  // State
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'State',
    status: 'Optional (filters)',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'State',
    status: 'Optional (filters, merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'State',
    status: 'Required',
    section: 'Constituent - Address',
  },

  // Street Address 1
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Street Address 1',
    status: 'Optional',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Street Address 1',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Street Address 1',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Street Address 1',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Street Address 1',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Street Address 1',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Street Address 1',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Street Address 1',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Street Address 1',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Street Address 1',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Street Address 1',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Street Address 1',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Street Address 1',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Street Address 1',
    status: 'Required',
    section: 'Constituent - Address',
  },

  // Street Address 2
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Street Address 2',
    status: 'Optional',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Street Address 2',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Street Address 2',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Street Address 2',
    status: 'Required',
    section: 'Constituent - Address',
  },

  // Latitude
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Latitude',
    status: 'Recommended',
    section: 'Constituent - Address',
  },

  // Longitude
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Longitude',
    status: 'Recommended',
    section: 'Constituent - Address',
  },

  // SECTION: Constituent - Affiliations

  // Affiliation Name
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Optional',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Required',
    section: 'Constituent - Affiliations',
  },

  // Affiliation Value
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Optional',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },

  // SECTION: Constituent - Solicit Codes

  // Solicit Code Name
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Solicit Code Name',
    status: 'Recommended',
    section: 'Constituent - Solicit Codes',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Solicit Code Name',
    status: 'Recommended',
    section: 'Constituent - Solicit Codes',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Solicit Code Name',
    status: 'Recommended',
    section: 'Constituent - Solicit Codes',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Solicit Code Name',
    status: 'Recommended',
    section: 'Constituent - Solicit Codes',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Solicit Code Name',
    status: 'Recommended',
    section: 'Constituent - Solicit Codes',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Solicit Code Name',
    status: 'Recommended',
    section: 'Constituent - Solicit Codes',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Solicit Code Name',
    status: 'Recommended',
    section: 'Constituent - Solicit Codes',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Solicit Code Name',
    status: 'Required',
    section: 'Constituent - Solicit Codes',
  },

  // SECTION: Constituent - Activities

  // Activity Name
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Activity Name',
    status: 'Optional',
    section: 'Constituent - Activities',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Activity Name',
    status: 'Required',
    section: 'Constituent - Activities',
  },

  // Activity Type
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Activity Type',
    status: 'Optional',
    section: 'Constituent - Activities',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Activity Type',
    status: 'Recommended',
    section: 'Constituent - Activities',
  },

  // Start Date
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Start Date',
    status: 'Optional',
    section: 'Constituent - Activities',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Start Date',
    status: 'Optional',
    section: 'Constituent - Activities',
  },

  // End Date
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'End Date',
    status: 'Optional',
    section: 'Constituent - Activities',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'End Date',
    status: 'Optional',
    section: 'Constituent - Activities',
  },

  // Year
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Year',
    status: 'Optional',
    section: 'Constituent - Activities',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Year',
    status: 'Optional',
    section: 'Constituent - Activities',
  },

  // SECTION: Constituent - Degrees

  // External ID
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'External ID',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'External ID',
    status: 'Required',
    section: 'Constituent - Degrees',
  },

  // Institution
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Institution',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Institution',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },

  // College
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'College',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'College',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },

  // Degree Type
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Degree Type',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Degree Type',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },

  // Year (Degrees)
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Year',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Year',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },

  // Name (Major/Minor)
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Name',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Name',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },

  // Major or Minor
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Major or Minor',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Major or Minor',
    status: 'Optional',
    section: 'Constituent - Degrees',
  },

  // SECTION: Spouse & Relative Data

  // Relative Constituent ID
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Relative Constituent ID',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Relative Constituent ID',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Relative Constituent ID',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Relative Constituent ID',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // Relative Type
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Relative Type',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Relative Type',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Relative Type',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Relative Type',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // First Name (Spouse & Relative)
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'First Name',
    status: 'Optional',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'First Name',
    status: 'Optional',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'First Name',
    status: 'Optional',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'First Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'First Name',
    status: 'Optional',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'First Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'First Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'First Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'First Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // Last Name (Spouse & Relative)
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Last Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Last Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Last Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Last Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Last Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // Preferred Email (Spouse & Relative)
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Preferred Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Preferred Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Preferred Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Preferred Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // Business Email (Spouse & Relative)
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // Other Email (Spouse & Relative)
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // Birth Date (Spouse & Relative)
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // Deceased (Spouse & Relative)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // SECTION: Gift Data

  // Gift Transaction ID
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Gift Transaction ID',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Gift Transaction ID',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Gift Transaction ID',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Gift Transaction ID',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },

  // Opportunity ID
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Opportunity ID',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Opportunity ID',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // Amount
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Amount',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },

  // Payment Date
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Payment Date',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Payment Date',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Payment Date',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Payment Date',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },

  // Fiscal Year
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Fiscal Year',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // Gift Type
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Gift Type',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Gift Type',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Gift Type',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Gift Type',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },

  // Anonymous
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Anonymous',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // Gift Source
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Gift Source',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // Custom Information 1
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },

  // Custom Information 2
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Smart Ask Amounts',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Email Outreach',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Texting',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },

  // Designation
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Designation',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Smart Segments',
    field: 'Designation',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // Designation Amount
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Designation Amount',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // Backend
  {
    product: 'Outreach',
    feature: 'Recurring Gift Smart Appeals',
    field: 'Backend',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Anniversary Smart Appeals',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'Donor Statuses',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Outreach',
    feature: 'Donor Statuses',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: '1st-Time Donor Matches',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // Write In
  {
    product: 'Wealth',
    feature: 'Core',
    field: 'Write In',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Online Giving',
    feature: 'GC Wealth Alerts',
    field: 'Write In',
    status: 'Optional',
    section: 'Gift Data',
  },
  {
    product: 'Wealth',
    feature: 'GC Wealth Alerts',
    field: 'Write In',
    status: 'Optional',
    section: 'Gift Data',
  },

  // SECTION: Portfolio Assignments

  // Assignment Type
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Assignment Type',
    status: 'Recommended',
    section: 'Portfolio Assignments',
  },

  // Gift Officer ID
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Officer ID',
    status: 'Required',
    section: 'Portfolio Assignments',
  },

  // SECTION: Interactions

  // Interaction ID
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Interaction ID',
    status: 'Required',
    section: 'Interactions',
  },

  // Contact Method
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Contact Method',
    status: 'Required',
    section: 'Interactions',
  },

  // Date of Interaction
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Date of Interaction',
    status: 'Required',
    section: 'Interactions',
  },

  // Content
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Content',
    status: 'Recommended',
    section: 'Interactions',
  },

  // Title
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Title',
    status: 'Recommended',
    section: 'Interactions',
  },

  // Task ID
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Task ID',
    status: 'Optional',
    section: 'Interactions',
  },

  // Custom Attribute
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Custom Attribute',
    status: 'Optional',
    section: 'Interactions',
  },

  // Custom Attribute Type
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Custom Attribute Type',
    status: 'Optional',
    section: 'Interactions',
  },

  // Gift Officer / Primary
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Officer / Primary',
    status: 'Optional',
    section: 'Interactions',
  },

  // Gift Officer / Gift Officer ID
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Officer / Gift Officer ID',
    status: 'Optional',
    section: 'Interactions',
  },

  // Constituent / Primary
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Constituent / Primary',
    status: 'Optional',
    section: 'Interactions',
  },

  // Constituent / Primary ID
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Constituent / Primary ID',
    status: 'Optional',
    section: 'Interactions',
  },

  // SECTION: Tasks

  // Task ID
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Task ID',
    status: 'Optional',
    section: 'Tasks',
  },

  // Gift Officer ID (Tasks)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Officer ID',
    status: 'Optional',
    section: 'Tasks',
  },

  // State
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'State',
    status: 'Optional',
    section: 'Tasks',
  },

  // Due Date
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Due Date',
    status: 'Optional',
    section: 'Tasks',
  },

  // Finished Date
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Finished Date',
    status: 'Optional',
    section: 'Tasks',
  },

  // Title (Tasks)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Title',
    status: 'Optional',
    section: 'Tasks',
  },

  // Description
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Description',
    status: 'Optional',
    section: 'Tasks',
  },

  // Stage
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Stage',
    status: 'Optional',
    section: 'Tasks',
  },

  // Solicitation Plan ID
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Solicitation Plan ID',
    status: 'Optional',
    section: 'Tasks',
  },

  // SECTION: Solicitation Plans

  // Solicitation Plan ID (Plans)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Solicitation Plan ID',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // Solicitation Plan Type
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Solicitation Plan Type',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // Name (Plans)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Name',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // Solicitation Plan Stage
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Solicitation Plan Stage',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // Start Date (Plans)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Start Date',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // End Date (Plans)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'End Date',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // Narrative
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Narrative',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // Gift Officer / Primary (Plans)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Officer / Primary',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // Gift Officer / Gift Officer ID (Plans)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Officer / Gift Officer ID',
    status: 'Optional',
    section: 'Solicitation Plans',
  },

  // SECTION: Opportunities

  // Name (Opportunities)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Name',
    status: 'Optional',
    section: 'Opportunities',
  },

  // Opportunity ID
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Opportunity ID',
    status: 'Required',
    section: 'Opportunities',
  },

  // Ask Date
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Ask Date',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Ask Amount
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Ask Amount',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Expected Ask Date
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Expected Ask Date',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Expected Ask Amount
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Expected Ask Amount',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Expected Amount
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Expected Amount',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Expected Response Date
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Expected Response Date',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Response Date
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Response Date',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Received Amount
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Received Amount',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Opportunity Status
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Opportunity Status',
    status: 'Required',
    section: 'Opportunities',
  },

  // Opportunity Type
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Opportunity Type',
    status: 'Required',
    section: 'Opportunities',
  },

  // Opportunity Notes
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Opportunity Notes',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Likelihood
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Likelihood',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Solicitation Plan ID (Opportunities)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Solicitation Plan ID',
    status: 'Recommended',
    section: 'Opportunities',
  },

  // Gift Officer / Primary (Opportunities)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Officer / Primary',
    status: 'Optional',
    section: 'Opportunities',
  },

  // Gift Officer / Gift Officer ID (Opportunities)
  {
    product: 'GO',
    feature: 'GC GO',
    field: 'Gift Officer / Gift Officer ID',
    status: 'Optional',
    section: 'Opportunities',
  },

  // SECTION: Personalization

  // Ask Amount (Personalization)
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Ask Amount',
    status: 'Recommended',
    section: 'Personalization',
  },

  // Display Name
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Display Name',
    status: 'Recommended',
    section: 'Personalization',
  },

  // Greeting Message
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Greeting Message',
    status: 'Recommended',
    section: 'Personalization',
  },

  // Designation Backend
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Designation Backend',
    status: 'Recommended',
    section: 'Personalization',
  },

  // Designation Amount
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Personalization',
  },

  // Tag
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Tag',
    status: 'Recommended',
    section: 'Personalization',
  },

  // Payer Name
  {
    product: 'Online Giving',
    feature: 'Personalization',
    field: 'Payer Name',
    status: 'Optional',
    section: 'Personalization',
  },

  // ============================================
  // ONLINE GIVING - SMART SEGMENTS (cloned from Outreach Smart Segments)
  // ============================================

  // Constituent ID - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // First Name - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // Last Name - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // Preferred First Name - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Preferred First Name',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Biographical Data',
  },

  // Preferred Email - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // Business Email - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Other Email - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Birth Date - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Cell Phone - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Cell Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Class Year - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Class Year',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Deceased - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Total Years Giving - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Total Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Consecutive Years Giving - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Consecutive Years Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Fiscal Year Giving - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Fiscal Year Giving',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Prospect Status - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Prospect Status',
    status: 'Optional',
    section: 'Constituent - Biographical Data',
  },

  // Constituent - Address Country - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Constituent - Address Country',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },

  // Constituent - AddressCity - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Constituent - AddressCity',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },

  // Zipcode - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Zipcode',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },

  // State - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'State',
    status: 'Optional (filters, merge tokens)',
    section: 'Constituent - Address',
  },

  // Street Address 1 - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Street Address 1',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },

  // Street Address 2 - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Street Address 2',
    status: 'Optional (merge tokens)',
    section: 'Constituent - Address',
  },

  // Affiliation Name - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },

  // Affiliation Value - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },

  // First Name (Spouse & Relative) - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'First Name',
    status: 'Optional',
    section: 'Spouse & Relative Data',
  },

  // Gift Transaction ID - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },

  // Amount - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },

  // Payment Date - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },

  // Gift Type - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },

  // Gift Source - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // Custom Information 1 - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Custom Information 1',
    status: 'Optional',
    section: 'Gift Data',
  },

  // Custom Information 2 - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Custom Information 2',
    status: 'Optional',
    section: 'Gift Data',
  },

  // Designation - Online Giving Smart Segments
  {
    product: 'Online Giving',
    feature: 'Smart Segments',
    field: 'Designation',
    status: 'Optional',
    section: 'Gift Data',
  },

  // VM data remains unchanged from original file
  {
    product: 'VM',
    feature: 'Core',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Middle Name',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Suffix',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Nickname',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Preferred First Name',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Former Last Name',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Class Year',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Preferred Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Home Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Cell Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Consecutive Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Prospect Status',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Ask Amount',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Marital Status',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Job Title',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Employer',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Work Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Business Address Street 1',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Business Address Street 2',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Business Address Street 3',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Business Address City',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Business Address State',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Business Address Zip',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Business Address Country',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Affiliation Name',
    status: 'Optional',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Affiliation Year',
    status: 'Optional',
    section: 'Constituent - Affiliations',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Street Address 1',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Street Address 2',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'City',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'State',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Zipcode',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Country',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Label',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Solicit Code Name',
    status: 'Recommended',
    section: 'Constituent - Solicit Codes',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Selectable',
    status: 'Recommended',
    section: 'Constituent - Solicitation and Visibility',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Edit Selectable Status',
    status: 'Recommended',
    section: 'Constituent - Solicitation and Visibility',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Solicitation Note',
    status: 'Recommended',
    section: 'Constituent - Solicitation and Visibility',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Relative Constituent ID',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'First Name / Last Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'First Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Class Year',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Activity Name',
    status: 'Recommended',
    section: 'Constituent - Activities',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Activity Type',
    status: 'Recommended',
    section: 'Constituent - Activities',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Year',
    status: 'Recommended',
    section: 'Constituent - Activities',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'External ID',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Degree Type',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Year',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'College',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Major or Minor',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Payment Date',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Gift Type',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Gift Transaction ID',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM',
    feature: 'Core',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // ============================================
  // VOLUNTEER MANAGEMENT: REIMAGINED
  // Sits alongside the other products (the legacy VM tab is separate)
  // ============================================

  // Constituent - Biographical Data
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Constituent ID',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'First Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Last Name',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Preferred Email',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Class Year',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Cell Phone',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Home Phone',
    status: 'Required',
    section: 'Constituent - Biographical Data',
  },

  // Constituent - Address
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Street Address 1',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Street Address 2',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Zipcode',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Constituent - AddressCity',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'State',
    status: 'Required',
    section: 'Constituent - Address',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Constituent - Address Country',
    status: 'Required',
    section: 'Constituent - Address',
  },

  // Constituent - Affiliations
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Affiliation Name (e.g. alumni, parent)',
    status: 'Required',
    section: 'Constituent - Affiliations',
  },

  // Constituent - Solicit Codes
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Solicit Code Name',
    status: 'Required',
    section: 'Constituent - Solicit Codes',
  },

  // Constituent - Activities
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Activity Name',
    status: 'Required',
    section: 'Constituent - Activities',
  },

  // Constituent - Degrees
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'External ID',
    status: 'Required',
    section: 'Constituent - Degrees',
  },

  // Gift Data
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Gift Transaction ID',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Amount',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Gift Type',
    status: 'Required',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Payment Date',
    status: 'Required',
    section: 'Gift Data',
  },

  // --- VM Reimagined: Recommended (aligned with GO's shared-section fields) ---

  // Constituent - Biographical Data
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Preferred First Name',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Prefix',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Former Last Name',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Business Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Other Email',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Preferred Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Work Phone',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Ask Amount',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Lifetime Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Employer',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Job Title',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Total Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Consecutive Years Giving',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },

  // Constituent - Address
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Latitude',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Longitude',
    status: 'Recommended',
    section: 'Constituent - Address',
  },

  // Constituent - Affiliations
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Affiliation Value (e.g. 2007, Upper School)',
    status: 'Recommended',
    section: 'Constituent - Affiliations',
  },

  // Constituent - Activities
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Activity Type',
    status: 'Recommended',
    section: 'Constituent - Activities',
  },

  // Constituent - Degrees
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Institution',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'College',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Degree Type',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Year',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },

  // Spouse & Relative Data
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Relative Constituent ID',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Relative Type',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'First Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Last Name',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Preferred Email',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Birth Date',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Deceased',
    status: 'Recommended',
    section: 'Spouse & Relative Data',
  },

  // Gift Data
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Opportunity ID',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Fiscal Year',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Anonymous',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Gift Source',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Designation',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Designation Amount',
    status: 'Recommended',
    section: 'Gift Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Backend',
    status: 'Recommended',
    section: 'Gift Data',
  },

  // --- VM Reimagined: carried over from legacy VMS recommended fields ---
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Middle Name',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Nickname',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Suffix',
    status: 'Recommended',
    section: 'Constituent - Biographical Data',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Constituent - Address Label',
    status: 'Recommended',
    section: 'Constituent - Address',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Year',
    status: 'Recommended',
    section: 'Constituent - Activities',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Major or Minor',
    status: 'Recommended',
    section: 'Constituent - Degrees',
  },
  {
    product: 'VM Reimagined',
    feature: 'VM Reimagined',
    field: 'Selectable',
    status: 'Recommended',
    section: 'Constituent - Solicitation and Visibility',
  },
]

// Helper functions to extract unique values
export function getUniqueProducts(): string[] {
  const products = new Set(fieldRequirementsData.map((item) => item.product))
  return Array.from(products).sort()
}

export function getUniqueFeatures(selectedProducts?: string[]): string[] {
  let data = fieldRequirementsData

  if (selectedProducts && selectedProducts.length > 0) {
    data = data.filter((item) => selectedProducts.includes(item.product))
  }

  const features = new Set(data.map((item) => item.feature))
  const featuresArray = Array.from(features)

  // Filter out "Core" if it only belongs to GO, VM, or Wealth product
  // GO, VM, and Wealth should not have selectable features - they show all fields automatically
  const filteredFeatures = featuresArray.filter((feature) => {
    if (feature === 'Core') {
      // Check if Core belongs to any product other than GO, VM, or Wealth
      const coreProducts = data
        .filter((item) => item.feature === 'Core')
        .map((item) => item.product)

      const hasNonSpecialCore = coreProducts.some(
        (product) =>
          product !== 'GO' && product !== 'VM' && product !== 'Wealth',
      )

      // Only include Core if it belongs to products other than GO/VM/Wealth
      return hasNonSpecialCore
    }
    // Filter out GC Wealth Alerts - Wealth shows all fields automatically
    if (feature === 'GC Wealth Alerts') {
      // Only show Wealth Alerts if it belongs to a non-Wealth product (like Online Giving)
      const wealthAlertProducts = data
        .filter((item) => item.feature === 'GC Wealth Alerts')
        .map((item) => item.product)

      const hasNonWealthProduct = wealthAlertProducts.some(
        (product) => product !== 'Wealth',
      )

      return hasNonWealthProduct
    }
    // Filter out VM Reimagined - its data needs are foundational, not feature specific
    if (feature === 'VM Reimagined') {
      return false
    }
    return true
  })

  // Remove "GC" prefix from feature names
  return filteredFeatures
    .map((feature) => {
      if (feature === 'GC Wealth Alerts') {
        return 'Wealth Alerts'
      }
      if (feature === 'GC GO') {
        return 'GO'
      }
      return feature
    })
    .sort()
}

export function getFilteredFields(
  selectedProducts: string[],
  selectedFeatures: string[],
): FieldWithSources[] {
  if (selectedProducts.length === 0) {
    return []
  }

  let filtered = fieldRequirementsData.filter((item) =>
    selectedProducts.includes(item.product),
  )

  // Normalize feature names for comparison (remove GC prefix)
  const normalizeFeature = (feature: string) => {
    if (feature === 'GC Wealth Alerts') return 'Wealth Alerts'
    if (feature === 'GC GO') return 'GO'
    return feature
  }

  const normalizedSelectedFeatures = selectedFeatures.map(normalizeFeature)

  // If features are selected, filter by features
  // EXCEPT for GO, VM, and Wealth products - they always show all their fields
  if (normalizedSelectedFeatures.length > 0) {
    filtered = filtered.filter((item) => {
      // GO, VM, and Wealth products bypass feature filtering
      if (
        item.product === 'GO' ||
        item.product === 'VM' ||
        item.product === 'Wealth' ||
        item.product === 'VM Reimagined'
      ) {
        return true
      }
      // Other products use normal feature filtering
      return normalizedSelectedFeatures.includes(normalizeFeature(item.feature))
    })
  } else {
    // When no features are selected:
    // - Show GO, VM, and Wealth fields (they don't require feature selection)
    // - Hide other products' fields (they require feature selection)
    filtered = filtered.filter((item) => {
      return (
        item.product === 'GO' ||
        item.product === 'VM' ||
        item.product === 'Wealth' ||
        item.product === 'VM Reimagined'
      )
    })
  }

  // Group by section + field name, keeping track of all sources
  // (the same field name can legitimately appear in multiple sections,
  // e.g. "First Name" in Biographical Data and in Spouse & Relative Data)
  const fieldMap = new Map<string, FieldWithSources>()

  filtered.forEach((item) => {
    const key = `${item.section}|${item.field}`
    const existing = fieldMap.get(key)
    // For GO, VM, and Wealth, show just the product name as source
    // Remove "GC" prefix from feature names in sources
    let source: string
    if (
      item.product === 'GO' ||
      item.product === 'VM' ||
      item.product === 'Wealth' ||
      item.product === 'VM Reimagined'
    ) {
      source = item.product
    } else {
      const featureName = normalizeFeature(item.feature)
      source = `${item.product} - ${featureName}`
    }

    if (!existing) {
      fieldMap.set(key, {
        ...item,
        sources: [source],
      })
    } else {
      // Add source if not already present
      if (!existing.sources.includes(source)) {
        existing.sources.push(source)
      }
    }
  })

  return Array.from(fieldMap.values()).sort((a, b) => {
    // Sort by section first (A-Z)
    const sectionCompare = a.section.localeCompare(b.section)
    if (sectionCompare !== 0) {
      return sectionCompare
    }

    // Finally by field name (A-Z)
    return a.field.localeCompare(b.field)
  })
}

// Separate fields into VM and non-VM groups
export function getFieldsByProduct(
  selectedProducts: string[],
  selectedFeatures: string[],
): { vmFields: FieldWithSources[]; otherFields: FieldWithSources[] } {
  const allFields = getFilteredFields(selectedProducts, selectedFeatures)

  const vmFields: FieldWithSources[] = []
  const otherFields: FieldWithSources[] = []

  allFields.forEach((field) => {
    // Check if this field is used by VM
    const hasVM = field.sources.some(
      (source) => source === 'VM' || source.startsWith('VM -'),
    )
    // Check if this field is used by non-VM products
    const hasOther = field.sources.some(
      (source) => source !== 'VM' && !source.startsWith('VM -'),
    )

    if (hasVM) {
      vmFields.push(field)
    }
    if (hasOther) {
      otherFields.push(field)
    }
  })

  return { vmFields, otherFields }
}
